import { IDraftOrder } from '@customTypes/draftOrder';
import { RerequisitionType } from '@customTypes/requisition';

export function getDraftRerequisitionType(draft: IDraftOrder): RerequisitionType | undefined {
  const type = draft.rerequisition_type ?? draft.formdata?.rerequisition_type;
  if (type) {
    return type;
  }

  if (draft.rerequisition_from ?? draft.formdata?.rerequisition) {
    return RerequisitionType.REANALYSIS;
  }

  return undefined;
}

export function isReanalysisDraft(draft: IDraftOrder): boolean {
  return getDraftRerequisitionType(draft) === RerequisitionType.REANALYSIS;
}

export function isMethylationReflexDraft(draft: IDraftOrder): boolean {
  return getDraftRerequisitionType(draft) === RerequisitionType.METHYLATION_REFLEX;
}

function draftMatchesOriginalRequisition(draft: IDraftOrder, originalRequisitionId: string): boolean {
  return draft.rerequisition_from === originalRequisitionId || draft.formdata?.rerequisition === originalRequisitionId;
}

export function findActiveRerequisitionDraftForRequisition(
  drafts: IDraftOrder[],
  originalRequisitionId: string,
  rerequisitionType: RerequisitionType,
): IDraftOrder | undefined {
  const matches = drafts.filter(
    draft =>
      draft.status === 'ACTIVE' &&
      getDraftRerequisitionType(draft) === rerequisitionType &&
      draftMatchesOriginalRequisition(draft, originalRequisitionId),
  );

  if (matches.length === 0) {
    return undefined;
  }

  return matches.sort((a, b) => b.updated_at.localeCompare(a.updated_at))[0];
}

export function findActiveReanalysisDraftForRequisition(
  drafts: IDraftOrder[],
  originalRequisitionId: string,
): IDraftOrder | undefined {
  return findActiveRerequisitionDraftForRequisition(drafts, originalRequisitionId, RerequisitionType.REANALYSIS);
}

export function findActiveMethylationReflexDraftForRequisition(
  drafts: IDraftOrder[],
  originalRequisitionId: string,
): IDraftOrder | undefined {
  return findActiveRerequisitionDraftForRequisition(
    drafts,
    originalRequisitionId,
    RerequisitionType.METHYLATION_REFLEX,
  );
}
